import React, { useState, useEffect } from "react";
import {calculateAge} from "../utils/calculateAge.js";

const CodeProfile = () => {
    const age = calculateAge();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const code = `// Over mij
const profile = {
    name: "Jennifer Coenraad",
    age: ${age},
    role: "Student Software Developer",
    hobbies: [
        "Gamen", "Dansen", "Tijd doorbrengen met vrienden",
        "Norse mythologie", "Cosplay", "Lekker (ijs) eten",
        "Zingen", "Muziek luisteren"
    ],
    personality: [
        "Vriendelijk", "Betrouwbaar", "Sociaal", "Behulpzaam",
        "Enthousiast", "Perfectionistisch", "Leergierig"
    ]
};`;

    const code_mobile = `// Over mij
const profile = {
    name: "Jennifer Coenraad",
    age: ${age},
    role: "Student Software Developer",
    hobbies: [
        "Gamen", "Dansen", 
        "Tijd doorbrengen met vrienden",
        "Norse mythologie", "Cosplay", 
        "Lekker (ijs) eten", "Zingen", 
        "Muziek luisteren"
    ],
    personality: [
        "Vriendelijk", 
        "Betrouwbaar", 
        "Sociaal", 
        "Behulpzaam",
        "Enthousiast", 
        "Perfectionistisch", 
        "Leergierig"
    ]
};`;

    const lines = (isMobile ? code_mobile : code).split('\n');

    return (
        <div className="codeblock text-gray-100 font-mono p-3 rounded-xl shadow-lg max-w-sm mx-auto">
            <pre className="code-content">
                {lines.map((line, index) => (
                    <div key={index} className="code-line">
                        <span className="line-number">{index + 1}</span>
                        <span className="line-content">{line}</span>
                    </div>
                ))}
            </pre>
        </div>
    );
};

export default CodeProfile;
